import React, { useMemo } from "react";
import { Badge } from "antd";
import { ScanStatuses } from "@/utils/enum";

const colorMap = {
  [ScanStatuses.NOT_SCANNED]: "default",
  [ScanStatuses.SUCCESS]: "success",
  [ScanStatuses.FAIL]: "error",
  [ScanStatuses.MANUAL_SUCCESS]: "success",
  [ScanStatuses.MANUAL_FAIL]: "error",
};

const textMap = {
  [ScanStatuses.NOT_SCANNED]: "Not Scanned",
  [ScanStatuses.SUCCESS]: "Success",
  [ScanStatuses.FAIL]: "Fail",
  [ScanStatuses.MANUAL_SUCCESS]: "Manual success",
  [ScanStatuses.MANUAL_FAIL]: "Manual Fail",
};

const ScanStatusBadge = ({ status: propStatus }) => {
  const status = useMemo(() => {
    if (propStatus === null) {
      return ScanStatuses.NOT_SCANNED;
    }

    return propStatus;
  }, [propStatus]);

  const { statusColor, statusText } = useMemo(() => {
    return {
      statusColor: colorMap[status],
      statusText: textMap[status],
    };
  }, [status]);

  return <Badge status={statusColor} text={statusText} />;
};

export default ScanStatusBadge;
